<template>
    <div v-if="showNotification || hasError">
        <article v-if="showNotification" role="alert" class="notification mb15-xs is-danger">
            <div class="media">
                <div class="media-content">
                    <span v-if="v && v.$error">{{ $t('pleaseProvideAllInformation') }}</span>
                    <span v-if="hasError">
                        <p class="lg">
                            <template v-if="typeof eInfo == 'string'">
                                {{ eInfo }}
                            </template>

                            <template
                                v-else-if="
                                    eInfo && eInfo.response && eInfo.response.data && eInfo.response.data.message
                                ">
                                {{ eInfo.response.data.message }}
                                <a
                                    href="javascript:void(0);"
                                    class="txt strong"
                                    @click.prevent="showErrorDetails = true">
                                    {{ $t('details') }}
                                </a>
                            </template>

                            <template v-else-if="eInfo && eInfo.status">
                                {{ eInfo.status }} {{ eInfo.code }} {{ eInfo.message }}
                                <a
                                    href="javascript:void(0);"
                                    class="txt strong"
                                    @click.prevent="showErrorDetails = true">
                                    {{ $t('details') }}
                                </a>
                            </template>
                            <template v-else>
                                {{ $t('somethingWentWrong') }}
                            </template>
                        </p>
                    </span>
                </div>
            </div>
        </article>

        <template v-if="hasError">
            <modal v-model="showErrorDetails">
                <template v-slot:header>
                    <div class="modal-title">{{ $t('somethingWentWrong') }}</div>
                </template>
                <template v-slot:content>
                    <div>
                        <div class="tags has-addons" v-if="eInfo">
                            <span class="tag is-danger" v-if="eInfo.response">
                                {{ eInfo.response.status }}
                            </span>
                            <span class="tag is-danger" v-if="eInfo.status">
                                {{ eInfo.status }}
                            </span>
                            <span class="tag" v-if="eInfo.config">
                                {{ eInfo.config.url }}
                            </span>
                        </div>
                        <template v-if="eInfo && eInfo.message">
                            <p class="lg mb15-xs">{{ eInfo.code }} {{ eInfo.message }}</p>
                        </template>
                        <template v-if="eInfo && eInfo.request && eInfo.request.data">
                            <div>Request:</div>
                            <pre class="scroll">
                                <code>{{eInfo.request.data}}</code>
                            </pre>
                        </template>
                        <template v-if="eInfo && eInfo.response && eInfo.response.data">
                            <div>Response:</div>
                            <pre class="scroll">
                                <code>{{eInfo.response.data}}</code>
                            </pre>
                        </template>
                        <template v-if="eInfo && eInfo.stack">
                            <div>Stack:</div>
                            <pre class="scroll">
                                <code>{{eInfo.stack}}</code>
                            </pre>
                        </template>
                        <!--
                        <a href="#" class="txt fade">
                            {{ $t("notifications.contactUs") }}
                        </a>-->
                    </div>
                </template>
            </modal></template
        >
    </div>
</template>

<script>
import modal from './modal.vue';
import useModal from './../composables/useModal.js';

export default {
    name: 'HasError',
    props: [
        'e', // for displaying details of the error
        'v',
    ],
    components: {
        modal,
    },
    setup(props, context) {
        return useModal(props, context);
    },
    data() {
        return {
            showErrorDetails: false,
        };
    },
    computed: {
        showNotification() {
            return this.hasError || (this.v && this.v.$error);
        },
        hasError() {
            return this.e ? true : false;
        },
        eInfo() {
            if (this.e) {
                return this.e;
                return JSON.parse(JSON.stringify(this.e));
            }
            return '';
        },
    },
    methods: {},
    i18n: {
        messages: {
            en: {
                pleaseProvideAllInformation: 'Please provide all information',
                somethingWentWrong: 'Something went wrong',
                details: 'Details',
                close: 'Close',
            },
            fr: {
                pleaseProvideAllInformation: 'Veuillez fournir toutes les informations',
                somethingWentWrong: "Quelque chose s'est mal passé",
                details: 'Détails',
                close: 'Fermer',
            },
            nl: {
                pleaseProvideAllInformation: 'Geef alle informatie aub',
                somethingWentWrong: 'Er liep iets mis',
                details: 'Details',
                close: 'Sluiten',
            },
        },
    },
};
</script>
